export function notifySignUp(user, token) {
  window.parent.postMessage({
    type: 'SIGN_UP',
    user,
    token
  }, '*');
}
